import { Popover } from 'antd'
import React from 'react'
import { SPARTACUS_SCORE_DRIVER_TOOLTIPS } from 'src/constants/spartacusTooltips'
import {
  getSpartacusRiskScoreTone,
  getSpartacusUpgradeScoreTone,
} from 'src/utils/spartacusMappers'
import styled from 'styled-components/macro'

function SpartacusScoreCell({ score, drivers = [], variant = 'upgrade' }) {
  const title =
    variant === 'risk' ? 'Risk score drivers' : 'Upgrade score drivers'
  const helper =
    variant === 'risk'
      ? SPARTACUS_SCORE_DRIVER_TOOLTIPS.risk
      : SPARTACUS_SCORE_DRIVER_TOOLTIPS.upgrade
  const tone =
    variant === 'risk'
      ? getSpartacusRiskScoreTone(score)
      : getSpartacusUpgradeScoreTone(score)

  const content = (
    <PopoverBody>
      <HelperText>{helper}</HelperText>
      {drivers.length > 0 ? (
        <DriverList>
          {drivers.map(driver => (
            <li key={driver.label}>
              {driver.label}
              {driver.points != null ? ` (+${driver.points})` : ''}
            </li>
          ))}
        </DriverList>
      ) : (
        <MutedText>No drivers recorded for this venue.</MutedText>
      )}
    </PopoverBody>
  )

  return (
    <Popover content={content} title={title} trigger='click'>
      <ScoreButton type='button' $tone={tone}>
        {score ?? '—'}
      </ScoreButton>
    </Popover>
  )
}

const PopoverBody = styled.div`
  max-width: 280px;
`

const HelperText = styled.p`
  color: ${({ theme }) => theme.colours.darkGrey};
  font-size: 13px;
  margin: 0 0 8px;
`

const DriverList = styled.ul`
  margin: 0;
  padding-left: 18px;
`

const MutedText = styled.p`
  color: ${({ theme }) => theme.colours.oliveGrey};
  font-size: 13px;
  margin: 0;
`

const ScoreButton = styled.button`
  background: none;
  border: none;
  color: ${({ $tone, theme }) => {
    if ($tone === 'positive') {
      return theme.colours.lettuceGreen
    }
    if ($tone === 'warning') {
      return theme.colours.orange
    }
    if ($tone === 'negative') {
      return theme.colours.chilliRed
    }
    return theme.colours.oliveGrey
  }};
  cursor: pointer;
  font: inherit;
  font-weight: 600;
  padding: 0;
  text-decoration: underline;
  text-decoration-style: dotted;

  &:hover {
    color: ${({ theme }) => theme.colours.bbqBlack};
  }
`

export default SpartacusScoreCell
